import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL || '/api';

export default function SolicitacaoDemanda() {
  const { slug } = useParams();
  const [cliente, setCliente] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [form, setForm] = useState({ nome: '', titulo: '', descricao: '', prioridade: 'media' });
  const [enviado, setEnviado] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  useEffect(() => {
    axios.get(`${baseURL}/public/cliente/${slug}`)
      .then(r => setCliente(r.data))
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#0a0f1e' }}>
        <div className="text-center text-white">
          <div className="mb-4 opacity-50 flex justify-center">
            <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          </div>
          <p className="text-xl font-bold mb-2">Link não encontrado</p>
          <p className="text-gray-400 text-sm">Verifique o link enviado pela sua agência.</p>
        </div>
      </div>
    );
  }

  if (!cliente) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: '#0a0f1e' }}>
        <div className="w-8 h-8 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setErro('');
    try {
      await axios.post(`${baseURL}/public/solicitar/${slug}`, {
        titulo: form.titulo,
        descricao: form.descricao,
        prioridade: form.prioridade,
        solicitante: form.nome,
      });
      setEnviado(true);
    } catch (err) {
      setErro(err.response?.data?.error || 'Erro ao enviar. Tente novamente.');
    } finally {
      setEnviando(false);
    }
  };

  const nomeCliente = cliente.nome_fantasia || cliente.razao_social;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 relative overflow-hidden" style={{ background: '#0a0f1e' }}>
      <Toaster position="top-right" />

      <img src="/icone-legacy.png" alt="" aria-hidden="true"
        style={{ position: 'fixed', right: '-60px', bottom: '-60px', width: '400px', opacity: 0.05, pointerEvents: 'none' }} />

      <div className="w-full max-w-md relative z-10">
        <div className="text-center mb-8">
          <div style={{ fontFamily: "'Montserrat', 'Arial Black', sans-serif", fontWeight: 900, fontSize: 40, letterSpacing: '-1px', lineHeight: 1, userSelect: 'none' }}>
            <span style={{ color: '#ffffff' }}>Le</span>
            <span style={{ color: '#3B3BAF' }}>g</span>
            <span style={{ color: '#ffffff' }}>acy</span>
          </div>
          <p className="text-xs tracking-widest uppercase mt-1" style={{ color: '#3B3BAF' }}>Assessoria de Marketing e Vendas</p>
        </div>

        {enviado ? (
          <div className="rounded-2xl p-8 text-center" style={{ background: '#111827', border: '1px solid #1e2748' }}>
            <div className="mb-4 flex justify-center text-green-400">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
            </div>
            <h2 className="text-xl font-black text-white mb-2">Solicitação enviada!</h2>
            <p className="text-sm text-gray-400 mb-6">Recebemos sua demanda e nossa equipe irá analisá-la em breve.</p>
            <button
              onClick={() => { setForm({ nome: '', titulo: '', descricao: '', prioridade: 'media' }); setEnviado(false); }}
              className="w-full py-3 rounded-xl text-sm font-bold text-white"
              style={{ background: 'linear-gradient(135deg, #3B3BAF 0%, #5B5BD6 100%)' }}>
              Enviar outra solicitação
            </button>
          </div>
        ) : (
          <div className="rounded-2xl p-8" style={{ background: '#111827', border: '1px solid #1e2748' }}>
            <div className="mb-6">
              <p className="text-xs font-semibold uppercase tracking-wider mb-1" style={{ color: '#3B3BAF' }}>Solicitação para</p>
              <h2 className="text-xl font-black text-white">{nomeCliente}</h2>
              <p className="text-sm mt-1" style={{ color: '#6b7280' }}>Preencha o formulário abaixo para solicitar uma demanda à equipe Legacy.</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-xs font-semibold uppercase tracking-wider mb-2" style={{ color: '#6b7280' }}>Seu nome *</label>
                <input
                  className="w-full px-4 py-3 rounded-xl text-sm text-white outline-none transition-all"
                  style={{ background: '#0a0f1e', border: '1px solid #1e2748' }}
                  value={form.nome}
                  onChange={e => set('nome', e.target.value)}
                  onFocus={e => e.target.style.borderColor = '#3B3BAF'}
                  onBlur={e => e.target.style.borderColor = '#1e2748'}
                  placeholder="Ex: João Silva"
                  required />
              </div>

              <div>
                <label className="block text-xs font-semibold uppercase tracking-wider mb-2" style={{ color: '#6b7280' }}>Título da demanda *</label>
                <input
                  className="w-full px-4 py-3 rounded-xl text-sm text-white outline-none transition-all"
                  style={{ background: '#0a0f1e', border: '1px solid #1e2748' }}
                  value={form.titulo}
                  onChange={e => set('titulo', e.target.value)}
                  onFocus={e => e.target.style.borderColor = '#3B3BAF'}
                  onBlur={e => e.target.style.borderColor = '#1e2748'}
                  placeholder="Ex: Post de promoção de fim de semana"
                  required />
              </div>

              <div>
                <label className="block text-xs font-semibold uppercase tracking-wider mb-2" style={{ color: '#6b7280' }}>Descrição *</label>
                <textarea
                  className="w-full px-4 py-3 rounded-xl text-sm text-white outline-none transition-all resize-none"
                  style={{ background: '#0a0f1e', border: '1px solid #1e2748' }}
                  rows={4}
                  value={form.descricao}
                  onChange={e => set('descricao', e.target.value)}
                  onFocus={e => e.target.style.borderColor = '#3B3BAF'}
                  onBlur={e => e.target.style.borderColor = '#1e2748'}
                  placeholder="Descreva o que você precisa, incluindo detalhes, referências, datas importantes..."
                  required />
              </div>

              <div>
                <label className="block text-xs font-semibold uppercase tracking-wider mb-2" style={{ color: '#6b7280' }}>Urgência</label>
                <div className="grid grid-cols-3 gap-2">
                  {[
                    { val: 'baixa', label: 'Baixa', emoji: '🟢' },
                    { val: 'media', label: 'Média', emoji: '🟡' },
                    { val: 'alta', label: 'Alta', emoji: '🔴' },
                  ].map(p => (
                    <button type="button" key={p.val} onClick={() => set('prioridade', p.val)}
                      className="py-2.5 rounded-xl text-sm font-semibold transition-all"
                      style={{
                        background: form.prioridade === p.val ? 'linear-gradient(135deg, #3B3BAF 0%, #5B5BD6 100%)' : '#0a0f1e',
                        border: `1px solid ${form.prioridade === p.val ? '#5B5BD6' : '#1e2748'}`,
                        color: form.prioridade === p.val ? '#ffffff' : '#6b7280',
                      }}>
                      {p.emoji} {p.label}
                    </button>
                  ))}
                </div>
              </div>

              {erro && <p className="text-sm text-red-400">{erro}</p>}

              <button type="submit" disabled={enviando}
                className="w-full py-3.5 rounded-xl text-sm font-bold text-white transition-all mt-2 disabled:opacity-60"
                style={{ background: 'linear-gradient(135deg, #3B3BAF 0%, #5B5BD6 100%)', boxShadow: '0 4px 24px #3B3BAF44' }}>
                {enviando ? 'Enviando...' : 'Enviar solicitação →'}
              </button>
            </form>
          </div>
        )}

        <p className="text-center text-xs mt-6" style={{ color: '#374151' }}>
          Legacy Assessoria de Marketing e Vendas
        </p>
      </div>
    </div>
  );
}
